import type { Translations } from './messages';

export const en: Translations = {
  'nav.home': 'Home',
  'nav.expertise': 'Expertise',
  'nav.engagement': 'Engagement',
  'nav.caseStudies': 'Case Studies',
  'nav.itServices': 'IT Services',
  'nav.blog': 'Blog',
  'nav.contact': 'Contact Us',
  'nav.solutions': 'Solutions',
  'nav.dashboard': 'Dashboard',
  'nav.logout': 'Logout',
  'nav.signIn': 'Sign In',
  'nav.signUp': 'VYE Solutions',
  
  'hero.eyebrow': 'VYE — شريكك الاستراتيجي للابتكار والتحول الرقمي في مصر',
  'hero.eyebrowEn': 'VYE — Your Strategic Partner for Digital Transformation & Advanced IT Solutions in Egypt',
  'hero.badge': 'VYE Next-Gen Technology Solutions',
  'hero.title': 'Partnering with Egyptian Tech Startups:',
  'hero.titleHighlight': 'Building Scalable Mobile Applications',
  'hero.description': 'We partner with Egyptian tech startups to design and build scalable, user-centric mobile applications that accelerate growth.',
  'hero.ctaPrimary': 'Start Your Project',
  'hero.ctaSecondary': 'View Our Work',
  
  'flagship.title': 'Who We Are — Technology Experts with Local Insight',
  'flagship.description': 'VYE is a Cairo-based IT solutions company specializing in delivering end-to-end technology services. We combine global technical expertise with a deep understanding of the Egyptian market to implement robust digital transformation roadmaps.',
  'flagship.cardTitle': 'Matjaar Cloud Platform',
  'flagship.cardDesc': 'The comprehensive solution for e-commerce management and creation in the Egyptian market.',
  'flagship.cardEn': 'Integrated e-commerce and automation for merchants.',
  'flagship.cardCta': 'Launch your store on Matjaar',
  
  'features.eyebrow': 'Our Vision — Empowering Businesses to Build a Stronger Digital Future',
  'features.eyebrowEn': 'Our Vision — Empowering Businesses to Build a Stronger Digital Future',
  'features.badge': 'Our Strategic Vision',
  'features.title': 'Empowering Businesses to Build a Stronger Digital Future',
  'features.description': 'We believe technology is a vital strategic driver. Our objective is to guide enterprises in Egypt toward operational excellence, reduced costs, hardened cybersecurity, and data-driven decision-making with scalable infrastructures.',
  'features.c1.title': 'Digital Transformation',
  'features.c1.desc': 'Modernize legacy workflows with tailored digital strategies, seamless tool integrations, and comprehensive team training.',
  'features.c2.title': 'Business Automation',
  'features.c2.desc': 'Automate HR, invoicing, accounting, and operations to minimize errors and maximize velocity.',
  'features.c3.title': 'Cloud & Cybersecurity Services',
  'features.c3.desc': 'Ensure ironclad data integrity with secure hosting, migration, active threat monitoring, and vulnerability assessments.',
  'features.c4.title': 'Custom Software Development',
  'features.c4.desc': 'Build bespoke web applications, enterprise-grade e-commerce solutions, and customized ERP systems.',
  'features.cta.title': 'Ready to Get Started?',
  'features.cta.desc': 'Reach out to the VYE team today and book a free consultation to discover how we can transform your business.',
  'features.cta.btn': 'Book a Free Consultation',
  'pricing.cta.title': 'Ready to Start a Strategic Partnership?',
  'pricing.cta.desc': 'Choose the model that fits your business and connect with our experts for a custom engagement plan.',
  'pricing.cta.btn': 'Contact Us Today',
  'scrollyTitle': 'Our Next-Gen Services',
  'scrollySubtitle': 'Empowering businesses with cutting-edge technology and innovative digital strategies.',
  'scrolly_f1_title': 'Matjaar Cloud Platform',
  'scrolly_f1_desc': 'The comprehensive e-commerce solution built specifically for the Egyptian market, featuring complete automation, payments, and shipping integrations.',
  'scrolly_f2_title': 'Hybrid Cloud Infrastructure',
  'scrolly_f2_desc': 'Design and deployment of scalable, resilient cloud systems that keep operations running smoothly while optimizing total cost of ownership.',
  'scrolly_f3_title': 'Enterprise Cybersecurity',
  'scrolly_f3_desc': 'Proactive, around-the-clock defense mechanisms and threat intelligence designed to keep your business critical assets safe from sophisticated cyber threats.',
  'scrolly_f4_title': 'Custom Software Engineering',
  'scrolly_f4_desc': 'High-performance web and mobile applications custom-coded to fit your unique processes and deliver world-class digital experiences.',
  
  'pricing.eyebrow': 'Unmatched Technical Partnership',
  'pricing.eyebrowEn': 'Strategic engagement models for sustainable scale',
  'pricing.badge': 'Engagement Models',
  'pricing.title': 'Strategic Partnership for Accelerated Growth',
  'pricing.description': 'Flexible service models designed to align perfectly with your operational needs and scale.',
  'pricing.c1.title': 'Full-Project Delivery',
  'pricing.c1.desc': 'End-to-end technology partner—from planning and architecture to deployment and support.',
  'pricing.c2.title': 'Dedicated Development Teams',
  'pricing.c2.desc': 'Integrate our elite engineers directly into your internal team to accelerate development velocity.',
  'pricing.c3.title': 'Ready SaaS Products',
  'pricing.c3.desc': 'Deploy innovative cloud platforms optimized for specific industries, like our flagship Matjaar platform.',
  
  'it.badge': 'Corporate IT Solutions & Services',
  'it.title': 'Our Integrated Suite of Services:',
  'it.titleHighlight': 'Business Technology Solutions',
  'it.description': 'We offer a wide range of tech solutions for business to help you excel. Whether you are a startup or a large enterprise, our expertise in it services egypt ensures you get the support you need. Our services are designed to be scalable and cost-effective, ensuring maximum return on your technology investment.',
  'it.subtitle': 'Comprehensive Enterprise IT',
  'it.subdescription': 'We specialize in crafting bespoke strategies that align with your unique operational needs to solve complex challenges.',
  'it.coreTitle': 'Our Core Service Offerings',
  'it.c1.title': 'Digital Transformation',
  'it.c1.desc': 'Modernize legacy workflows to reduce operational bottlenecks by up to 40% and accelerate your digital transformation journey.',
  'it.c2.title': 'Business Automation',
  'it.c2.desc': 'Deploy automated invoicing and customer service platforms that eliminate manual data entry and increase team productivity by 60%.',
  'it.c3.title': 'Cloud & Security Solutions',
  'it.c3.desc': 'Migrate to resilient cloud architectures with 99.99% uptime, backed by penetration testing to protect your sensitive data.',
  'it.c4.title': 'Custom Software Development',
  'it.c4.desc': 'Build scalable Vue.js/Node.js applications and custom ERPs designed to handle 10x traffic growth without performance degradation.',
  'it.c5.title': 'Technical Support',
  'it.c5.desc': 'Receive 24/7 proactive monitoring and incident response that reduces server downtime and resolves endpoint issues in under 15 minutes.',
  
  'it.partnerTitle': 'Why Choose VYE as Your Technology Solutions Partner?',
  'it.partnerDesc': 'Our deep expertise in the local market, technical capabilities, robust execution methodologies, and 24/7 premium support structures make VYE the ideal technology partner in Egypt.',
  'it.partnerCta': 'Get in Touch with Our Experts',
  
  'contact.eyebrow': 'Begin Your Digital Transformation',
  'contact.eyebrowEn': 'Reach out and let our experts bring your vision to life',
  'contact.title': 'Contact Us',
  'contact.description': 'We are here to assist with any inquiries. Our dedicated support team will respond promptly.',
  'contact.nameLabel': 'Full Name',
  'contact.namePlaceholder': 'John Doe',
  'contact.emailLabel': 'Email Address',
  'contact.emailPlaceholder': 'name@domain.com',
  'contact.subjectLabel': 'Inquiry Subject',
  'contact.subjectPlaceholder': 'Enterprise IT Services Consultation',
  'contact.messageLabel': 'Message Details',
  'contact.messagePlaceholder': 'Please describe your inquiry here...',
  'contact.submit': 'Send Message',
  'contact.successMsg': 'Your message has been sent successfully. We will be in touch soon!',
  'contact.infoTitle': 'Reach Us Directly',
  'contact.phone': '+20 100 123 4567',
  'contact.phoneLabel': 'Phone',
  'contact.whatsapp': 'https://wa.me/201001234567',
  'contact.whatsappLabel': 'WhatsApp',
  'contact.email': 'contact@vye.onl',
  'contact.emailContactLabel': 'Email',
  'contact.address': 'The GrEEK Campus, 28 Falaki St, Bab Al Louq, Cairo, Egypt',
  'contact.addressLabel': 'Address',
  
  'seo.eyebrow': 'Technology Experts with Local Insight',
  'seo.title': 'Digital Transformation & Business Automation in Egypt',
  'seo.description': 'Deploy modern technology frameworks, optimize business processes, and launch scalable digital solutions configured for the Egyptian market.',
  'seo.c1.title': 'Digital Transformation Solutions',
  'seo.c1.desc': 'Re-engineer core operations using modern frameworks and digital methodologies.',
  'seo.c2.title': 'Business Automation & Cloud Services',
  'seo.c2.desc': 'Integrate ERP systems, automate reporting, and scale hybrid cloud deployments.',
  'seo.c3.title': 'Software Development Outsourcing',
  'seo.c3.desc': 'Acquire dedicated developers, software engineers, and QA teams for your custom projects.',
 
  'faq.eyebrow': 'Frequently Asked Questions',
  'faq.title': 'Answers to Your Technology Queries',
  'faq.description': 'Find out how VYE can accelerate your digital transformation in Egypt.',
  'faq.q1': 'What is cloud computing and how can it benefit my business in Egypt?',
  'faq.a1': 'Cloud computing provides flexible, scalable access to computing resources via the internet. It helps Egyptian businesses reduce IT overhead, improve team collaboration, and ensure secure data accessibility from anywhere.',
  'faq.q2': 'How can I protect my business from cyber threats in Egypt?',
  'faq.a2': 'We implement robust cybersecurity services including managed threat detection, secure data backup and recovery, and comprehensive network security solutions to defend your digital assets against evolving threats.',
  'faq.q3': 'What types of software does VYE develop?',
  'faq.a3': 'We provide custom software development in Egypt, specializing in enterprise SaaS platforms, scalable web/mobile applications, and complex system integrations designed to optimize business processes.',
  'faq.q4': 'What are managed IT services and what do they include?',
  'faq.a4': 'Our managed IT services in Egypt offer proactive tech support for companies. We handle IT infrastructure modernization, 24/7 system monitoring, cloud management, and strategic IT consulting so you can focus on core growth.',
 
  'footer.rights': 'All rights reserved.',

  'blog.eyebrow': 'Tech Blog',
  'blog.title': 'Latest Articles & Insights',
  'blog.description': 'Explore the latest tech trends, digital transformation tips, and comparison studies on Cloud solutions and SaaS in the Egyptian market.',
  
  'solutions.eyebrow': 'Our Innovative Platforms & Software Solutions',
  'solutions.eyebrowEn': 'Our Innovative Platforms & Software Solutions',
  'solutions.badge': 'VYE Software Solutions',
  'solutions.title': 'Bespoke Software Solutions to Empower Your Business',
  'solutions.description': 'We build and run production-ready SaaS platforms specifically tailored to help merchants and enterprises automate workflows, grow sales, and scale fast.',
  'solutions.matjaar.title': 'Matjaar Cloud Platform',
  'solutions.matjaar.desc': 'The ultimate fully-automated e-commerce management suite in Egypt. Create, custom-brand, and run your online storefront with built-in logistics, shipping integrations, payments gateway, and smart analytics designed for speed.',
  'solutions.matjaar.badge': 'Available Now',
  'solutions.matjaar.feature1': 'E-commerce API Engine',
  'solutions.matjaar.feature2': 'Local Payment Gateways',
  'solutions.matjaar.feature3': 'Inventory Sync',
  'solutions.matjaar.cta': 'Discover Matjaar',
  'solutions.comingsoon.title': 'VYE Enterprise Hub',
  'solutions.comingsoon.desc': 'Coming soon - we are engineering a comprehensive enterprise platform covering HR, accounting, and full business process automation, built specifically for Egypt\'s fast-growing businesses.',
  'solutions.comingsoon.badge': 'Soon',
  'trust.heading': 'موثوق به من قِبَل شركات مصر الرائدة',
  'trust.headingEn': 'Trusted by Leading Egyptian Businesses',
  'testimonials.badge': 'Client Testimonials',
  'testimonials.title': 'What Our Partners Say',
  'footer.newsletter': 'Subscribe to our Tech Newsletter',
  'footer.newsletterPlaceholder': 'Your email address',
  'footer.newsletterCta': 'Subscribe'
};
